import { useCallback, useRef, useState } from 'react';

// Считает, сколько элементов фиксированной плотности помещается в контейнер,
// и (для сетки) сколько колонок влезает по ширине. Пересчёт на ResizeObserver —
// плотность держится постоянной, на больших экранах показываем больше строк
// и колонок вместо растягивания. Возвращает { ref, cols, rows, count }.
//
// ВАЖНО: ref здесь — callback-ref, а не useRef. Потребители (NovaNews/
// NovaTrending) до загрузки данных возвращают null, поэтому измеряемого узла
// на первом маунте нет. Callback-ref подключает наблюдатель ровно в тот момент,
// когда узел реально появляется в DOM (и переподключает при смене узла).
export default function useFitGrid({ rowHeight, rowGap = 0, minColWidth = 0, colGap = 0, minRows = 1, minCols = 1, maxCols = Infinity, maxRows = Infinity }) {
    const [dims, setDims] = useState({ cols: minCols, rows: minRows });
    const roRef = useRef(null);

    const ref = useCallback((node) => {
        if (roRef.current) { roRef.current.disconnect(); roRef.current = null; }
        if (!node) return;

        const measure = () => {
            const h = node.clientHeight;
            const w = node.clientWidth;
            let rows = Math.max(minRows, Math.floor((h + rowGap) / (rowHeight + rowGap)) || minRows);
            rows = Math.min(rows, maxRows);
            let cols = minColWidth > 0
                ? Math.max(minCols, Math.floor((w + colGap) / (minColWidth + colGap)) || minCols)
                : minCols;
            cols = Math.min(cols, maxCols);
            setDims((prev) => (prev.rows === rows && prev.cols === cols ? prev : { cols, rows }));
        };

        measure();
        const ro = new ResizeObserver(measure);
        ro.observe(node);
        roRef.current = ro;
    }, [rowHeight, rowGap, minColWidth, colGap, minRows, minCols, maxCols, maxRows]);

    return { ref, cols: dims.cols, rows: dims.rows, count: dims.cols * dims.rows };
}
